// extracted by mini-css-extract-plugin
export default {"gallery":"y3_VapJG","zone":"zone","disabledZone":"disabledZone","imageContainer":"EVMcuxDu","image":"Vw2NLV8M","imageInnerWrapper":"LJWUxw20","navigationWrapper":"RXoRyHCG"};